<nav class="nav nav-secondary mixed-loyalty-nav shadow">
  <!--Account-->
  <a
    class="nav-item"
    [routerLink]="['/account']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'account.nav.account.screenreader' | translate : { fgbdefault: 'Move to Account page' } }}"
  >
    <label>{{ 'account.nav.profile' | translate }}</label>
  </a>

  <!--Benefits-->
  <a
    class="nav-item"
    [routerLink]="['/benefits']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'account.nav.benefits.screenreader' | translate : { fgbdefault: 'Move to benefits page' } }}"
  >
    <label>{{ 'account.nav.benefits' | translate }}</label>
  </a>
</nav>
